function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from "vue";
import Dialog from "../nav/dialog";
import Sheet from "../nav/sheet";
import Snackbar from "../nav/snackbar";
import Vuetify from "vuetify";

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, null, [{
    key: "dialog",
    get: function get() {
      return LaunchDialog;
    }
  }, {
    key: "sheet",
    get: function get() {
      return LaunchSheet;
    }
  }, {
    key: "snackbar",
    get: function get() {
      return LaunchSnackbar;
    }
  }]);

  return _default;
}();

export { _default as default };

var LaunchDialog = /*#__PURE__*/function () {
  function LaunchDialog() {
    _classCallCheck(this, LaunchDialog);
  }

  _createClass(LaunchDialog, null, [{
    key: "_initStack",
    value: function _initStack() {
      if (!this.stack) {
        this.stack = [];
      }
    }
  }, {
    key: "topDialog",
    value: function topDialog() {
      this._initStack();

      return this.stack.last();
    }
  }, {
    key: "open",
    value: function open(properties, component) {
      if (!this.stack) {
        this.stack = [];
      } // https://css-tricks.com/creating-vue-js-component-instances-programmatically/


      var DialogClass = Vue.extend(Dialog);
      var instance = new DialogClass({
        vuetify: new Vuetify({
          theme: {
            themes: Utils.settings.themes
          }
        }),
        propsData: {
          spec: properties,
          stack: this.stack,
          vueApp: window.vueApp
        }
      });

      if (component) {
        // const placeholder = component
        //   .$dialogContainer()
        //   .appendChild(document.createElement("div"));
        var placeholder = component.$el.appendChild(document.createElement("div"));
        instance.$mount(placeholder);
      } else {
        console.error("A dialog has to be displayed in a component");
      }
    }
  }, {
    key: "reload",
    value: function reload(properties, component) {
      if (!this.stack) {
        return;
      }

      Utils.type.ifObject(this.stack.last(), function (dialog) {
        dialog.reload(properties);
      });
    }
  }, {
    key: "close",
    value: function close(properties, component) {
      if (!this.stack) {
        this.stack = [];
      }

      Utils.type.ifObject(this.stack.last(), function (dialog) {
        dialog.close();
      });
      Utils.type.ifObject(properties["onClose"], function (it) {
        Action.execute(it, component);
      });
    } // This is only meant to be used internally

  }, {
    key: "alert",
    value: function alert(message, component) {
      var properties = {
        message: message
      };
      var spec = Object.assign({}, properties, {
        buttons: [{
          text: "OK",
          onClick: properties.onClose
        }]
      });
      this.open(spec, component);
    }
  }]);

  return LaunchDialog;
}();

var LaunchSheet = /*#__PURE__*/function () {
  function LaunchSheet() {
    _classCallCheck(this, LaunchSheet);
  }

  _createClass(LaunchSheet, null, [{
    key: "open",
    value: function open(properties, component) {
      var SheetClass = Vue.extend(Sheet);
      var instance = new SheetClass({
        vuetify: new Vuetify({
          theme: {
            themes: Utils.settings.themes
          }
        }),
        propsData: {
          spec: properties
        }
      });

      if (component) {
        var placeholder = component.$el.appendChild(document.createElement("div"));
        instance.$mount(placeholder);
      } else {
        console.error("A sheet has to be displayed in a component");
      }

      return instance;
    }
  }, {
    key: "confirm",
    value: function confirm(properties, onConfirm, component) {
      var spec = Object.assign({}, properties, {
        buttons: [{
          text: "Confirm",
          onClickFunction: onConfirm
        }]
      });
      this.open(spec, component);
    }
  }, {
    key: "alert",
    value: function alert(message, buttons, component) {
      var spec = {
        message: message,
        buttons: buttons
      };
      this.open(spec, component);
    }
  }]);

  return LaunchSheet;
}();

var LaunchSnackbar = /*#__PURE__*/function () {
  function LaunchSnackbar() {
    _classCallCheck(this, LaunchSnackbar);
  }

  _createClass(LaunchSnackbar, null, [{
    key: "open",
    value: function open(properties, component) {
      var SnackbarClass = Vue.extend(Snackbar);
      var instance = new SnackbarClass({
        vuetify: window.vueApp.vuetify,
        propsData: {
          spec: properties,
          vueApp: window.vueApp
        }
      });

      if (component) {
        // This doesn't seem to work when it is triggered from a list row's menu.
        // const placeholder = component.$el.appendChild(
        //   document.createElement("div")
        // );
        var placeholder = document.body.appendChild(document.createElement("div"));
        instance.$mount(placeholder);
        instance.show = true;
      } else {
        console.error("A snackbar has to be displayed in a component");
      }

      return instance;
    }
  }, {
    key: "error",
    value: function error(message, component) {
      this.open({
        message: message,
        styleClasses: ["error"]
      }, component);
    }
  }, {
    key: "indicator",
    value: function indicator(message, component) {
      var instance = this.open({
        message: message,
        timeout: -1
      }, component);
      instance.indicator = true;
    }
  }]);

  return LaunchSnackbar;
}();